enum JourneyPublicationState {
    Published = 'Published',
    Unpublished = 'Unpublished',
}

export default JourneyPublicationState;
